// Debug: log ALL events to find what fires on quick-add
['cart:update', 'cart:add', 'cart:change', 'cart:updated'].forEach(name => {
  document.addEventListener(name, (e) => {
    console.log('EVENT FIRED:', name, JSON.stringify(e.detail));
  });
});

// Also catch any event with "cart" in the name
const origDispatch = EventTarget.prototype.dispatchEvent;
EventTarget.prototype.dispatchEvent = function(event) {
  if (event.type && event.type.includes('cart')) {
    console.log('CART EVENT:', event.type, event.detail);
  }
  return origDispatch.call(this, event);
};
